<template>
  <vetster-search-facet-group
    :label="$t('app.date')"
    group="DATE"
    :expandable="true"
    :expanded="expanded"
  >
    <div class="relative">
      <div
        ref="dateButton"
        class="pseudo-select hover:ring focus:ring hover:ring-neutral-100"
        @click="open = !open"
        @keydown="open = !open"
      >
        <span>{{ displayDate }}</span>
        <fa :icon="['fal', 'chevron-down']" />
      </div>

      <div
        ref="dayPicker"
        class="relative"
      >
        <vetster-day-picker
          v-show="open"
          :date="inputs.date_from"
          :timezone="inputs.timezone"
          class="absolute top-1 left-0 right-0 shadow-lg z-10 bg-white p-2 rounded-lg border border-neutral-300"
          @update="handleDay"
          @selected="onSelected"
        />
      </div>
    </div>
  </vetster-search-facet-group>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import { faChevronDown } from '@fortawesome/pro-light-svg-icons';
import { mapGetters, mapState } from 'vuex';

import VetsterDayPicker from '@/components/VetsterDayPicker';
import VetsterSearchFacetGroup from '@/components/VetsterSearchFacetGroup';
import clickaway from '@/mixins/ClickAway';

library.add(faChevronDown);

export default {
  name: 'VetsterSearchDayInput',

  components: {
    VetsterDayPicker,
    VetsterSearchFacetGroup,
  },

  mixins: [clickaway],

  props: {
    expandable: {
      default: false,
      type: Boolean,
    },
    expanded: {
      default: true,
      type: Boolean,
    },
  },

  data() {
    return {
      open: false,
    };
  },

  computed: {
    ...mapGetters('search', ['displayDate']),
    ...mapState('search', ['inputs']),
  },

  created() {
    document.addEventListener('click', this.registerClickAway);
  },

  methods: {
    handleDay(date) {
      this.$store.commit('search/setDates', { date_from: date });
      this.$store.commit('search/setInputs', { date_from: date });
    },
    onSelected() {
      this.open = false;
      this.$emit('date-selected');
    },
    registerClickAway(event) {
      this.hideOnClickAway(
        event,
        this.$refs.dateButton,
        () => { this.open = false; },
        this.$refs.dayPicker,
      );
    },
  },
};
</script>
